/**
 * Dialog di anteprima della newsletter come la riceverà il destinatario:
 * cornice fissa + template + contenuto, composti dal BE.
 *
 * L'HTML è mostrato in un iframe isolato (sandbox vuota): niente script, e gli stili
 * dell'email non interferiscono con quelli dell'applicazione.
 */
import PropTypes from 'prop-types';
import { Box, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { DefaultOutlinedButton } from '../../../../utils/Buttons';

export function PreviewDialog({ open, loading, html, onClose }) {
  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
      <DialogTitle sx={{ textAlign: 'center' }}>Anteprima</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box
            component="iframe"
            title="Anteprima newsletter"
            sandbox=""
            srcDoc={html || '<p style="font-family:sans-serif;color:#888">Nessun contenuto</p>'}
            sx={{ width: '100%', height: '60vh', border: 'none' }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <DefaultOutlinedButton onClick={onClose}>Chiudi</DefaultOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

PreviewDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  html: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default PreviewDialog;
